// One active focus boundary at a time, including nested platform dialogs.
const boundaries = [];
const candidates = 'button,input,select,textarea,a[href],[tabindex]';
export function containPopupFocus(content, { onDismiss, opener = document.activeElement } = {}) {
  const visible = element => element.getClientRects().length && getComputedStyle(element).visibility !== 'hidden';
  const items = () => [...content.querySelectorAll(candidates)].filter(element => element.tabIndex >= 0 && !element.disabled && visible(element));
  const boundary = {};
  boundaries.push(boundary);
  const active = () => boundaries[boundaries.length - 1] === boundary;
  const focus = () => (items()[0] || content).focus({ preventScroll: true });
  const previousTabIndex = content.getAttribute('tabindex');
  content.tabIndex = -1;
  const keydown = event => {
    if (!active() || !visible(content)) return;
    if (event.key === 'Escape') {
      // Let an open native/React combobox consume its own first Escape.
      const combobox = event.target.closest?.('[role="combobox"][aria-expanded="true"]');
      if (combobox && content.contains(combobox)) return;
      const nested = content.querySelector('.am5-custom-select.is-open .am5-custom-select-control');
      if (nested) { event.preventDefault(); event.stopImmediatePropagation(); nested.click(); nested.focus(); return; }
      if (onDismiss) { event.preventDefault(); event.stopImmediatePropagation(); onDismiss(); }
    }
    if (event.key === 'Tab') {
      const controls = items();
      const index = controls.indexOf(document.activeElement);
      if (!controls.length || index < 0 || (event.shiftKey ? index === 0 : index === controls.length - 1)) {
        event.preventDefault();
        (event.shiftKey ? controls[controls.length - 1] || content : controls[0] || content).focus();
      }
    }
  };
  const focusin = event => { if (active() && visible(content) && !content.contains(event.target)) focus(); };
  document.addEventListener('keydown', keydown, true);
  document.addEventListener('focusin', focusin);
  if (!content.contains(document.activeElement)) focus();
  let disposed = false;
  return { dispose() {
    if (disposed) return;
    disposed = true;
    boundaries.splice(boundaries.indexOf(boundary), 1);
    document.removeEventListener('keydown', keydown, true);
    document.removeEventListener('focusin', focusin);
    if (previousTabIndex === null) content.removeAttribute('tabindex');
    else content.setAttribute('tabindex', previousTabIndex);
    if (opener?.isConnected) opener.focus({ preventScroll: true });
  } };
}
